<div class="row">
  <div class="col-12">
    <h2 class="h1 font-weight-300">{{ 'digital_properties' | translate }}</h2>
  </div>
</div>
<div class="row mt-4 justify-content-between">
  <div class="col-auto">
    <app-searchbox
      id="taskNameFilter"
      role="search"
      [(ngModel)]="searchTerm"
      [label]="'search_by_dp_name' | translate"
      [placeholder]="'form_search' | translate"
    ></app-searchbox>
  </div>
  @if (canCreateDigitalProperty$ | async) {
    <div class="col-auto">
      <button
        id="create-digital-property"
        role="link"
        class="btn btn-lg btn-primary"
        type="button"
        (click)="onCreateDigitalProperty()"
      >
        {{ 'create_a_digital_property' | translate }}
      </button>
    </div>
  }
</div>
<div class="row mt-4">
  <div class="col-12 d-flex justify-content-end">
    <app-responsive-pagination
      [(page)]="page"
      [(pageSize)]="pageSize"
      [collectionSize]="dpCount$ | async"
      [entryLimits]="pageSizeLimits"
    ></app-responsive-pagination>
  </div>
</div>
<div class="row mt-4">
  @if (tableData$ | async; as tableData) {
    <div class="col-12">
      <app-ngb-table [config]="tableConfig" [data]="tableData" (onSort)="sort$.next($event)"> </app-ngb-table>
    </div>
  }
</div>
<div class="row mt-4">
  <div class="col-12 d-flex justify-content-end">
    <app-responsive-pagination
      idSuffix="Bottom"
      [(page)]="page"
      [(pageSize)]="pageSize"
      [collectionSize]="dpCount$ | async"
      [entryLimits]="pageSizeLimits"
    ></app-responsive-pagination>
  </div>
</div>
